module.exports = __webpack_public_path__ + "static/media/img-section02.a2235d1a.png";